// Apply remaining funds to principal -> Allow partial payment on line items: true  (TTTF)
//
// allow_partial_on_invoice: true
// allow_partial_on_line_item: true
// apply_extra_payment_to_principal: true
// include_scheduled: false

// Apply remaining funds to principal -> Allow partial payment on line items: false  (TFTF)
//
// allow_partial_on_invoice: true
// allow_partial_on_line_item: false
// apply_extra_payment_to_principal: true
// include_scheduled: false

// Apply remaining funds to next scheduled invoice -> Allow partial payment on line items: true (TTFT)
//
// allow_partial_on_invoice: true
// allow_partial_on_line_item: true
// apply_extra_payment_to_principal: false
// include_scheduled: true

// Apply remaining funds to next scheduled invoice -> Allow partial payment on line items: false (TFFT)
//
// allow_partial_on_invoice: true
// allow_partial_on_line_item: false
// apply_extra_payment_to_principal: false
// include_scheduled: true

// Do not apply remaining funds (FFFF)
//
// allow_partial_on_invoice: false
// allow_partial_on_line_item: false
// apply_extra_payment_to_principal: false
// include_scheduled: false

export default function getFundsQueryOptions(skipLineItemsIds) {
  const currentOptions = {};

  if (skipLineItemsIds.length) {
    currentOptions.skipLineItems = skipLineItemsIds.map((id) => ({
      line_item_id: id,
    }));
    currentOptions.allowPartialOnInvoice = true;
  } else {
    currentOptions.skipLineItems = [];
  }

  return currentOptions;
}
